import { render, staticRenderFns } from "./ItemCirculo.vue?vue&type=template&id=ca32dfd4&scoped=true&"
import script from "./ItemCirculo.vue?vue&type=script&lang=ts&"
export * from "./ItemCirculo.vue?vue&type=script&lang=ts&"
import style0 from "./ItemCirculo.vue?vue&type=style&index=0&id=ca32dfd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca32dfd4",
  null
  
)

export default component.exports